import * as React from 'react';
import * as _ from 'lodash-es';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PermissionTypes, ResourceTypes } from './constants';
import { hasPermission } from './helpers/Permission';
import Login from 'pages/Login/Login';
import Auth from 'pages/Auth/Auth';
import ResetPassword from 'pages/ResetPassword/ResetPassword';
import UserDetails from 'pages/Users/UserDetails';
import CompanyDetails from 'pages/Companies/CompanyDetails';
import MyAccount from 'pages/MyAccount/MyAccount';
import Lookup from 'pages/Lookup/Lookup';
import RefundChargeGoogleForm from 'pages/RefundChargeGoogleForm/RefundChargeGoogleForm';
import BookingDetails from 'pages/Bookings/BookingDetails';
import ManageTB from 'pages/ManageTB/ManageTB';
import ManageTBHotels from 'pages/ManageTBHotels/ManageTBHotels';
import ManageTBFeatures from 'pages/ManageTBFeatures/ManageTBFeatures';
import ManageTBSyncHotels from 'pages/ManageTBSyncHotels/ManageTBSyncHotels';
import AgencySingle from 'pages/Agencies/AgencySingle';
import ManageBlackBox from 'pages/ManageBlackBox/ManageBlackBox';
import ManageBlackBoxUsers from 'pages/ManageBlackBoxUsers/ManageBlackBoxUsers';
import ManageBlackBoxPermissions from 'pages/ManageBlackBoxPermissions/ManageBlackBoxPermissions';
import AuditLogs from 'pages/AuditLogs/AuditLogs';
import TriggerJob from 'pages/TriggerJob/TriggerJob';
import _404 from 'pages/404/404';
import { ReduxState } from './reducers/types';
import { connectWithRouter } from 'helpers/connectWithRouter';

const publicRoutes = ['/login', '/', '/auth'];

const manageBBRoutes = [
  '/manage-bb/',
  '/manage-bb/users',
  '/manage-bb/roles-permissions',
];
const withoutAgencyIdRoutes = [
  '/manage-tb',
  '/manage-tb/hotels',
  '/manage-tb/feature-flags',
];
const supportJobsRoutes = ['/support-jobs'];

class AppRouter extends React.Component<any, any> {
  componentWillMount() {
    if (!_.includes(publicRoutes, window.location.pathname)) {
      if (_.get(this.props.userLogin, 'isLoggedIn', false) === false) {
        this.props.navigate('/login', {replace: true});
      } else if (
        _.get(this.props.userLogin, 'forceResetPassword', false) === true
      ) {
        this.props.navigate('/change-password', {replace: true});
      }
    }

    if (_.includes(manageBBRoutes, window.location.pathname)) {
      if (!hasPermission('blackBox', PermissionTypes.read)) {
        this.props.navigate('/lookup', {replace: true});
      }
    }

    if (_.includes(supportJobsRoutes, window.location.pathname)) {
      if (!hasPermission(ResourceTypes.triggerJobs, PermissionTypes.create)) {
        this.props.navigate('/lookup', {replace: true});
      }
    }

    if (_.includes(withoutAgencyIdRoutes, window.location.pathname)) {
      const loginData = localStorage.getItem('login_data') as string;
      const parsedLoginData = JSON.parse(loginData);

      if (_.get(parsedLoginData, 'agencyId', '') ?? '') {
        this.props.navigate('/lookup', {replace: true});
      }
    }
  }

  render() {
    return (
      <Routes>
        <Route
          path="/"
          element={<Login />}
        />
        <Route
          path="/login"
          element={<Login />}
        />
        <Route
          path="/auth"
          element={<Auth />}
        />
        <Route
          path="/change-password"
          element={<ResetPassword />}
        />
        <Route
          path="/users/:userId"
          element={<UserDetails />}
        />
        <Route
          path="/company/:companyId"
          element={<CompanyDetails />}
        />
        <Route
          path="/account"
          element={<MyAccount />}
        />
        <Route
          path="/lookup"
          element={<Lookup />}
        />
        <Route
          path="/refund-charge"
          element={<RefundChargeGoogleForm />}
        />
        <Route
          path="/booking/:bookingId"
          element={<BookingDetails />}
        />
        <Route

          path="/manage-tb"
          element={<ManageTB />}
        />
        <Route
          path="/manage-tb/hotels"
          element={<ManageTBHotels />}
        />
        <Route
          path="/manage-tb/feature-flags"
          element={<ManageTBFeatures />}
        />
        <Route
          path="/manage-tb/sync-hotels"
          element={<ManageTBSyncHotels />}
        />
        <Route
          path="/agency/:agencyId"
          element={<AgencySingle />}
        />
        <Route

          path="/manage-bb"
          element={<ManageBlackBox />}
        />
        <Route
          path="/manage-bb/users"
          element={<ManageBlackBoxUsers />}
        />
        <Route
          path="/manage-bb/roles-permissions"
          element={<ManageBlackBoxPermissions />}
        />
        <Route
          path="/audit-events"
          element={<AuditLogs />}
        />
        <Route
          path="/support-jobs"
          element={<TriggerJob />}
        />
        <Route
          path="*"
          element={<_404 />}
        />
      </Routes>
    );
  }
}

// Wire up redux state to component
function mapStateToProps(state: ReduxState) {
  return {
    userLogin: state.userLogin,
  };
}

// Connect it to Redux
export default connectWithRouter(mapStateToProps, null)(AppRouter);

// ---- Hotel bookng related routes ----
// <HotelsList path="hotels/:userId" />
// <HotelDetails path="hotels/rooms/:userId" />
// <BookHotel path="hotels/checkout/:userId" />
// <HotelBookingConfirmation path="hotels/bookingconfirmation" />
